import * as React from "react";

function SvgAtatus(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 130.8 106.6"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style />
      <g id="Atatus_svg__Color_Icon_1_">
        <path
          d="M125.5 68.1l-24.6-23.8c-2.1-2-5.4-2-7.5 0L68.8 68.1c-2.1 2-2.1 5.3 0 7.3l24.6 23.8c2.1 2 5.4 2 7.5 0l24.6-23.8c2-2 2-5.3 0-7.3zm-10.2 6.7l-15 14.5c-1.8 1.7-4.6 1.7-6.4 0L79 74.8c-1.8-1.7-1.8-4.5 0-6.2l15-14.5c1.8-1.7 4.6-1.7 6.4 0l15 14.5c1.7 1.7 1.7 4.5-.1 6.2z"
          fill="#6c6"
          id="Atatus_svg__Green"
        />
        <path
          d="M93.3 31.4L68.7 7.5c-2.1-2-5.4-2-7.5 0L36.7 31.4c-2.1 2-2.1 5.3 0 7.3l24.6 23.8c2.1 2 5.4 2 7.5 0l24.6-23.8c1.9-2.1 1.9-5.4-.1-7.3zm-10.2 6.7l-15 14.5c-1.8 1.7-4.6 1.7-6.4 0l-15-14.5c-1.8-1.7-1.8-4.5 0-6.2l15-14.5c1.8-1.7 4.6-1.7 6.4 0l15 14.5c1.8 1.7 1.8 4.5 0 6.2z"
          fill="#dc5753"
          id="Atatus_svg__Red"
        />
        <path
          d="M61.1 68.1L36.5 44.3c-2.1-2-5.4-2-7.5 0L4.5 68.1c-2.1 2-2.1 5.3 0 7.3l24.6 23.8c2.1 2 5.4 2 7.5 0l24.6-23.8c2-2 2-5.3-.1-7.3zM51 74.8L36 89.3c-1.8 1.7-4.6 1.7-6.4 0l-15-14.5c-1.8-1.7-1.8-4.5 0-6.2l15-14.5c1.8-1.7 4.6-1.7 6.4 0l15 14.5c1.7 1.7 1.7 4.5 0 6.2z"
          fill="#fc6"
          id="Atatus_svg__Yellow"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAtatus);
